
import Vue from 'vue'
import wfAlert from './index.vue'
import Store from '../store'
let init = (options) => {
  let messageInstance = new (Vue.extend(wfAlert))({
    el: document.createElement('div'),
    data: { ...options }
  })
  messageInstance.$mount()
  document.body.appendChild(messageInstance.$el)
  return messageInstance
}


let caller = (type, title = '提示', content, btnText = '确定', btnType, showClose, cancelText= '取消') => {
  return new Promise((resolve, reject) => {
    // if (messageInstance) {
    //   messageInstance.$destroy()
    // }
    let messageInstance = init({ type, title, content, btnText, btnType, showClose, cancelText })
    messageInstance.show = true
    Store.addModalIndex(messageInstance.$el) // 添加modal
    messageInstance.confirm = () => {
      messageInstance.show = false
      Store.delModal() // 删除或降级modal
      resolve()
    }
    messageInstance.cancel = () => {
      messageInstance.show = false
      Store.delModal() // 删除或降级modal
      reject('cancel')
      // reject(new Error('cancel'))
      // return new Promise(() => {})
    }
  })
}


export default {
  install(vue) {
    vue.prototype.$wfAlert = caller
  }
}
